// Hero.jsx
import { motion } from 'framer-motion';
import { FaArrowRight, FaPhoneAlt, FaChevronDown } from 'react-icons/fa';
import { IMG, VIDEO } from '../../data/siteData';
import { useQuoteModal } from '../../context/QuoteModalContext';
import './Hero.css';

export default function Hero() {
  const { openQuote } = useQuoteModal();

  return (
    <section className="hero" id="home">
      <div className="hero__bg-video-wrap">
        <video
          className="hero__bg-video"
          src={VIDEO.heroHighway}
          poster={IMG.heroHighway}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />
      </div>

      <div className="hero__gradient" />
      <div className="hero__fog hero__fog--1" />
      <div className="hero__fog hero__fog--2" />

      <div className="hero__particles">
        {Array.from({ length: 22 }).map((_, i) => (
          <span
            key={i}
            className="hero__particle"
            style={{
              left: `${(i * 37) % 100}%`,
              animationDelay: `${(i % 10) * 0.8}s`,
              animationDuration: `${8 + (i % 6)}s`,
            }}
          />
        ))}
      </div>

      <div className="hero__content container">
        <motion.p
          className="eyebrowhero"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          Kerala &amp; Tamil Nadu Freight Network
        </motion.p>

        <motion.h1
          className="hero__title"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.15 }}
        >
          Reliable Truck &amp;<br /><span className="accent">Lorry</span> Transportation
        </motion.h1>

        <motion.p
          className="hero__subtitle"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.35 }}
        >
          Safe. Fast. Trusted logistics solutions — moving industrial goods, construction
          material, and long-distance freight across two states, every hour of every day.
        </motion.p>

        <motion.div
          className="hero__actions"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <button className="btn btn-primary" onClick={openQuote}>
            Get Quote <FaArrowRight />
          </button>
          <a href="tel:+919447713460" className="btn btn-outline">
            <FaPhoneAlt /> Call Now
          </a>
        </motion.div>
      </div>

      <motion.div
        className="hero__scroll"
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
      >
        <FaChevronDown />
      </motion.div>
    </section>
  );
}